// @codekit-prepend "src/slick.min.js";
$(document).ready(function() {
	$('a[href*="#"]:not([data-lity])').click(function(e) {
		let hash = '#' + $.attr(this, 'href').split('#')[1];

		if($(hash).length) {
			$('html, body').animate(
				{
					scrollTop: $(hash).offset().top - $('header').outerHeight(true)
				},
				800
			);
			return false;
		}

	});

	// on scroll added scrolled
	$(window).scroll(function() {
		if ($(window).scrollTop() > 0) {
			$('header').addClass('scrolled');
		} else {
			$('header').removeClass('scrolled');
		}

	});

	if($('.gallery__slider').length) {
		$('.gallery').each(function() {
			const parent = $(this);

			$(this).find('.gallery__slider').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				variableWidth: true,
				infinite: true,
				centerMode: true,
				adaptiveHeight: true,
				prevArrow: $(this).find('.arrow-left'),
				nextArrow: $(this).find('.arrow-right'),
				asNavFor: $(this).find('.gallery__infos-slider')
			});

			$(this).find('.gallery__infos-slider').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				infinite: true,
				asNavFor: $(this).find('.gallery__slider'),
				fade: true,
				prevArrow: $(this).find('.prev'),
				nextArrow: $(this).find('.next')
			});

			$(this).find('.gallery__infos-slider').on('afterChange', function(event, slick, currentSlide, nextSlide) {
				const current = currentSlide + 1;
				parent.find('.counter span:first-child').text('0' + current);
				parent.find('.slick-slide').removeClass('slick-target'); // Prevents the infinite from causing the transition to break

				if(currentSlide > 8) {
					parent.find('.counter span:first-child').text(current);
				}
			});


			// Prevents the infinite from causing the transition to break
			$(this).find('.gallery__infos-slider').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
				let nextIndex = currentSlide + 1; // assume moving right
				if(currentSlide-1 == nextSlide || (nextSlide+1 == slick.slideCount && currentSlide < nextSlide)) {
						nextIndex = currentSlide - 1; // nope, moving left
				}
				$(this).find(`[data-slick-index="${nextIndex}"]`).addClass('slick-target');
			});


		});
	}

	if($('.content-slider__slider').length) {
		$('.content-slider').each(function() {
			const parent = $(this);

			$(this).find('.content-slider__slider').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				fade: true,
				speed: 750,
				infinite: true,
				prevArrow: $(this).find('.content-slider__controller-previous'),
				nextArrow: $(this).find('.content-slider__controller-next')
			});

			$(this).find('.arrow-left').click(function() {
				parent.find('.content-slider__slider').slick('slickPrev');
			})
			$(this).find('.arrow-right').click(function() {
				parent.find('.content-slider__slider').slick('slickNext');
			})

			$(this).find('.content-slider__slider').on('afterChange', function(event, slick, currentSlide, nextSlide) {
				const current = currentSlide + 1;

				parent.find('.content-slider__controller-current').text('0' + current);

				if(currentSlide > 8) {
					parent.find('.content-slider__controller-current').text(current);
				}
			});
		})
	}

	jQuery(document).on('gform_post_render', function(){
		updateFieldPositions();
	});

	updateFieldPositions();

	const sections = gsap.utils.toArray('section');

	sections.forEach((section) => {
		ScrollTrigger.create({
			trigger: section,
			start: 'top 50%',
			end: 'bottom 50%',
			onEnter: () => {
				if(section.id.length) {
					toggleHeaderLinks(section.id);
				}
			},
			onEnterBack: () => {
				if(section.id.length) {
					toggleHeaderLinks(section.id);
				}
			}

		})
	});

	if($('.four-columns').length && window.innerWidth < 1024) {
		$('.four-columns').each(function() {
			const _this = $(this);

			_this.find('.row').slick({
				mobileFirst: true,
				fade: true,
				speed: 750,
				arrows: true,
				infinite: true,
				prevArrow: _this.find('.four-columns__controller-previous'),
				nextArrow: _this.find('.four-columns__controller-next'),
				responsive: [
					{
						breakpoint: 1024,
						settings: 'unslick'
					}
				]
			});

			_this.find('.row').on('afterChange', function(event, slick, currentSlide, nextSlide) {
				const current = currentSlide + 1;

				_this.find('.four-columns__controller-current').text('0' + current);

				if(currentSlide > 8) {
					_this.find('.four-columns__controller-current').text(current);
				}
			});

		});
	}

	$(window).on('resize', function() {
		if(window.innerWidth < 1024) {
			$('.content-slider__controller').each(function() {
				const image = $(this).parent().find('.content-slider__slider-image.large');
				const imageBottom = image.position().top + image.outerHeight(true);
				$(this).css('top', imageBottom + 'px');
			});

			$('.four-columns__controller').each(function() {
				const image = $(this).parent().find('.four-columns__column-image');
				const imageBottom = image.position().top + image.outerHeight(true);
				$(this).css('top', imageBottom + 'px');
			});

		}

		const heroTextHeight = $('.hero__text').outerHeight(true);
		const heroBlockHeight = $('.hero__block.d-lg-block').outerHeight(true);
		const headerHeight = $('header').outerHeight(true);

		$('.hero').css('min-height', heroTextHeight + heroBlockHeight + headerHeight + 20 + 37 + 'px');

	}).resize();

	$('.header__burger,.nav__links a').click(function() {
		$('.nav,.header__burger,.header__btn a,.header').toggleClass('active');
	});

	$('.header__btn a').click(function() {
		if($(this).hasClass('active')) {
			$('.nav,.header__burger,.header__btn a,.header').removeClass('active');
		}
	});

	/////////////////////////////////////////////////////////////////////////
	//// CSS variable setter
	webHeight();
	if(window.innerWidth >= 1024) {
		window.addEventListener('resize', webHeight);
	}

});

function updateFieldPositions() {
	if($('.form__form').length) {
		$('.form__form').each(function() {
			$(this).find('.gform_footer').appendTo($(this).find('.gform_fields'));
		});
	}
}

function toggleHeaderLinks(id) {
	$('header ul li a').removeClass('active');
	$('header ul li a[href="#' + id + '"]').addClass('active');

}

// * Safari height issues for iPad and iPhones
function webHeight() {
	const doc = document.documentElement;
	const headerHeight = $('header').outerHeight(true);
	doc.style.setProperty('--header-height', `${headerHeight}px`);
	doc.style.setProperty('--vp-height', `${window.innerHeight}px`);
}

function setCookie(name,value,days) {
	var expires = "";
	if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}
function eraseCookie(name) {
	document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function getMousePosition(el) {
	if (event.pageX < $(el).offset().left + $(el).width() / 2) {
		return 'left';
	} else {
		return 'right';
	}
}